function fn_comp_visual() {
    var $fn = $(".comp_visual");

    if($fn.length) {
        $fn.on("click","[data-scroll]",function (e) {
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $fn.height() - $("#layout_header").height()+20
            }, 1500);
        })
    }
}